import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const AccordionWrapper = styled(Flexbox)`
  box-shadow: 0 1px 4px rgb(0 0 0 / 8%), 0 0 2px rgb(0 0 0 / 3%);
  border-radius: 4px;
`;

export const AccordionHeader = styled(Flexbox)`
  cursor: pointer;
`;

export const AccordionBody = styled(Flexbox)``;
